import {dataTestId} from '@hconnect/uikit'
import {Box, useMediaQuery, useTheme} from '@mui/material'
import React from 'react'

import {DAY_PERIODS} from '../constants/measurementTypes'
import {StrengthTarget} from '../types'

import {StrengthTargetOverviewDesktopTable} from './StrengthTargetOverviewDesktopTable'
import {StrengthTargetOverviewMobileCards} from './StrengthTargetOverviewMobileCards'

interface StrengthTargetOverviewProps {
  targets: StrengthTarget[]
  timezone: string
  onEditTarget: (target: StrengthTarget) => void
}

export const StrengthTargetOverview: React.FC<StrengthTargetOverviewProps> = ({
  targets,
  timezone
}) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <Box {...dataTestId('strength_target_overview')}>
      {isMobile ? (
        <StrengthTargetOverviewMobileCards
          targets={targets}
          timezone={timezone}
          dayPeriods={DAY_PERIODS}
        />
      ) : (
        <StrengthTargetOverviewDesktopTable
          targets={targets}
          timezone={timezone}
          dayPeriods={DAY_PERIODS}
        />
      )}
    </Box>
  )
}
